<template>
  <div class="asset-item position-relative mx-2 mt-2 mb-0 rounded"
       :id="componentId"
       v-observe-visibility="onVisibilityChanged">
    <MediaContent :posterImage="articleHeader.image"
                  :programmeId="articleHeader.videoProgrammeId"
                  :keepInitiated="promoMode"
                  :isLocked="isLocked"
                  :isVisible="isVisible"
                  :ref="`${componentId}_mediaContent`"
                  @contentClicked="expandArticle"/>
    <div class="asset-badge fas fa-lock" v-show="isLocked"></div>
    <div class="pb-3 pl-3 pr-3 pt-2">
      <p id="title">{{articleHeader.headerText}}</p>
      <div id="content">
        <div v-if="isExpanded">
          <VueMarkdown class="markdown"
                       :source="articleContent.contents"
                       :anchorAttributes="{ target: '_blank' }"/>
          <span id="less" @click="collapseArticle">Read Less</span>
        </div>
        <div v-else id="preview">
          {{articleHeader.shortDescription}}
          <span id="more" @click="onItemClick">Read More</span>
        </div>
      </div>
      <div class="prog-stats">
        <span>By {{articleContent.author}}</span>
        <span>{{articleContent.pubDateFormatted}}</span>
      </div>
      <div id="expanded">
        <div id="buttons" class="asset-item-buttons vld-parent">
          <!-- Sharing buttons here, see Recommend.vue-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { ObserveVisibility } from 'vue-observe-visibility'
import MediaContent from '../components/MediaContent'
import VueMarkdown from 'vue-markdown'

export default {
  page: 'article',
  directives: { 'observe-visibility': ObserveVisibility },
  components: {
    MediaContent,
    VueMarkdown
  },
  data: function () {
    return {
      componentId: `article_${this.item.id}`,
      isExpanded: false,
      isVisible: false,
      articleHeader: this.item.articleMetadata.header,
      articleContent: this.item.articleMetadata.contents
    }
  },
  props: ['item', 'isShared', 'isOpenForAnonymous', 'promoMode'],
  computed: {
    ...mapState({
      isBeta: state => state.isBeta,
      isRegisteredUser: state => state.isRegisteredUser
    }),
    isLocked: function () {
      if (this.isOpenForAnonymous && !this.isBeta) {
        return false
      }
      if (this.isShared) {
        return false
      }
      if (this.item.isPlaceholder) {
        return false
      }
      if (this.isBeta && !this.isRegisteredUser) {
        return true
      }
      const signUpRequired = this.item.flags && this.item.flags.indexOf('SignupRequired') !== -1
      return signUpRequired && !this.isRegisteredUser
    }
  },
  methods: {
    onItemClick () {
      if (this.isLocked) {
        this.$store.commit('startSignIn', 'CONTENT_BLOCKED')
        return
      }
      this.$refs[`${this.componentId}_mediaContent`].onPosterClick()
    },

    expandArticle () {
      if (this.isLocked) {
        this.$store.commit('startSignIn', 'CONTENT_BLOCKED')
        return
      }
      this.isExpanded = true
    },

    collapseArticle () {
      this.$refs[`${this.componentId}_mediaContent`].$el
        .scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' })
      this.isExpanded = false
    },

    onVisibilityChanged (isVisible) {
      this.isVisible = isVisible
      if (!this.isVisible && this.isExpanded) {
        this.isExpanded = false
      }
    }
  }
}
</script>
